export default __webpack_public_path__ + "static/media/background-1.7d1e8c1d.jpg";